export const defaultTheme = {
  colors: {
    brandDarkGrey: '#000000de',
    brandMediumGrey: '#7e818b',
    brandGrey: '#a7a9b3',
    brandLightGrey: '#e1e4eb',
    brandBlue: '#375fda',
    brandPink: '#cb87eb',
    brandCyan: '#06b496',
    brandGreen: '#32c423',
    brandRed: '#ff3d3d',
    brandOrange: '#ea9f1a',
    inReviewOrange: '#EFC174',
    lightGrey1: '#f8f9fb',
    white: '#ffffff',
    lightGrey: '#F3F1F1',
    brandDarkBlack: '#24292D',
    // https://material-ui.com/customization/color/
    grey300: '#e0e0e0',
    grey400: '#bdbdbd',
    grey500: '#9e9e9e',
    skeleton: '#f4f7f9',
    sidebarBackground: '#FEFDFD',
    lightGrey2: '#F3F1F1',
    lightGrey3: '#F9F9F9',
    lightRed: '#FFE1EC',
  },
  sizes: {
    headerHeight: '54px',
    sidebarWidth: '240px',
    shrinkedSidebarWidth: '62px',
  },
  zIndex: {
    sidebar: 1,
    header: 3,
    backdrop: 100,
  },
};

export type ThemeColor = keyof typeof defaultTheme.colors;
